import { createFileRoute } from "@tanstack/react-router";

const Route = createFileRoute("/$pillar/")({ component: () => null });

export { Route };
